import React from 'react';
import Decimal from 'decimal.js';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_SHIPPING_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * A component that renders the shipping fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl } = props;

  const shippingFeeLineItems = lineItems.filter(
    item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal
  );
  const shippingFeeLineItem = shippingFeeLineItems[0];
  const shippingFeeTotal =
    shippingFeeLineItems.length > 0
      ? new Money(
          shippingFeeLineItems.reduce((amount, item) => {
            return amount.plus(item.lineTotal.amount);
          }, new Decimal(0)),
          shippingFeeLineItem.lineTotal.currency
        )
      : null;

  return shippingFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, shippingFeeTotal)}</span>
    </div>
  ) : null;
};

export default LineItemShippingFeeMaybe;
